import * as React from "react";
import { Anchor } from "../../typography/anchor/anchor.mjs";
import { Badge } from "../../badge/badge.mjs";
import { Icon } from "../../icon/icon/icon.mjs";
import { HeaderDropdown } from "../header-dropdown/header-dropdown.mjs";
const HeaderActionsItem = React.forwardRef(function HeaderActionsItem2(props, ref) {
  const {
    closeLabel,
    dropdownContainer,
    dropdownContent,
    dropdownContentRef,
    dropdownFooter,
    dropdownHeader,
    dropdownOffsetY,
    dropdownPadding = "small",
    dropdownSize = "small",
    dropdownLabelledBy,
    hideLabel = false,
    id,
    icon,
    isCurrent = false,
    isPlaceholder,
    label,
    labelClassName,
    location,
    onToggle,
    showArrow,
    badge,
    asModal,
    showOverlay,
    ...rest
  } = props;
  const labelBEM = () => {
    const classArray = ["header__actions-label"];
    if (labelClassName) {
      classArray.push(labelClassName);
    }
    return classArray.join(" ");
  };
  const buttonBEM = () => {
    const classArray = ["header__actions-button", "header__actions-button--".concat(id)];
    if (hideLabel) {
      classArray.push("header__actions-button--hide-label");
    }
    if (isCurrent) {
      classArray.push("is-current");
    }
    return classArray.join(" ");
  };
  const BEM = () => {
    const classArray = ["header__actions-item", "header__actions-item--".concat(id)];
    if (isPlaceholder) {
      classArray.push("header__actions-item--placeholder");
    }
    return classArray.join(" ");
  };
  const anchor = /* @__PURE__ */ React.createElement(Anchor, { isUnderlined: false, ref, ...rest, className: buttonBEM() }, /* @__PURE__ */ React.createElement("div", { className: "header__actions-button-inner" }, /* @__PURE__ */ React.createElement("div", { className: "header__actions-icon-wrapper" }, icon && /* @__PURE__ */ React.createElement(Icon, { modifiers: icon, className: "header__actions-icon" }), /* @__PURE__ */ React.createElement(Icon, { modifiers: "#close", className: "header__actions-icon header__actions-icon--close" }), (badge == null ? void 0 : badge.text) && /* @__PURE__ */ React.createElement(Badge, { text: badge.text, purpose: badge.purpose, className: "header__actions-badge", size: "small" })), /* @__PURE__ */ React.createElement("span", { className: labelBEM() }, closeLabel && isCurrent ? closeLabel : label), showArrow && /* @__PURE__ */ React.createElement(Icon, { modifiers: "#arrow-down", className: "header__actions-arrow" })));
  return /* @__PURE__ */ React.createElement("li", { className: BEM() }, dropdownContent && dropdownContainer ? /* @__PURE__ */ React.createElement(
    HeaderDropdown,
    {
      offsetY: dropdownOffsetY != null ? dropdownOffsetY : location === "bottom" ? 10 : 0,
      size: dropdownSize,
      padding: dropdownPadding,
      isShown: isCurrent,
      onToggle,
      reference: anchor,
      container: dropdownContainer,
      header: dropdownHeader,
      footer: dropdownFooter,
      contentRef: dropdownContentRef,
      id: "header-".concat(id, "-dropdown"),
      asModal,
      className: "header__dropdown--".concat(id),
      "aria-labelledby": dropdownLabelledBy
    },
    dropdownContent
  ) : anchor);
});
export {
  HeaderActionsItem
};
